import { File, FileArchive, FileAudio, FileCode, FileImage, FileSpreadsheet, FileText, FileVideo, Smartphone, type LucideIcon } from "lucide-react";

const BY_EXTENSION: Array<[RegExp, LucideIcon]> = [
  [/\.(zip|tar|tgz|gz|bz2|xz|7z|rar|zst|jar|dmg|iso)$/i, FileArchive],
  [/\.(apk|aab|ipa|xapk)$/i, Smartphone],
  [/\.(xlsx?|xlsm|ods|csv|tsv|numbers)$/i, FileSpreadsheet],
  [/\.(html?|xml|svg|js|mjs|cjs|ts|tsx|jsx|json|ya?ml|py|rb|go|rs|java|kt|swift|c|cc|cpp|h|sh|sql|css)$/i, FileCode],
  [/\.(png|jpe?g|gif|webp|bmp|heic|tiff?|ico)$/i, FileImage],
  [/\.(mp4|mov|webm|mkv|avi)$/i, FileVideo],
  [/\.(mp3|wav|m4a|ogg|flac|aac)$/i, FileAudio],
  [/\.(pdf|docx?|odt|rtf|pages|pptx?|key|md|txt|log)$/i, FileText],
];

/** An icon for a file by its extension: an archive, an app, a sheet, code — else a plain page. */
export function FileIcon({ filename, className }: { filename: string; className?: string }) {
  const Icon = BY_EXTENSION.find(([pattern]) => pattern.test(filename))?.[1] ?? File;
  return <Icon className={className} aria-hidden />;
}

/** "ZIP", "APK", "XLSX" — what the chip says a file is when it is not text, an image or a PDF. */
export function fileTypeLabel(filename: string, kind: "text" | "image" | "pdf" | "file"): string {
  if (kind === "pdf") return "PDF";
  if (kind === "text") return "text";
  if (kind === "image") return "image";
  const ext = /\.([a-z0-9]{1,8})$/i.exec(filename)?.[1];
  return ext ? ext.toUpperCase() : "file";
}
